import PropTypes from "prop-types";
import styles from "./index.css";

export const ProductMediaContainer = ({ children }) => (
  <div className={styles.productMediaContainer}>{children}</div>
);

ProductMediaContainer.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProductMediaContainer;
